"use strict";
const api = require('./api');
;
exports.buildTask = (props = {}) => ({
    id: undefined,
    createdAt: api.database.getServerTimestamp(),
    name: props.name || '',
    state: 0 /* STOPPED */,
    goal: exports.buildGoal(props.goal),
    currentSessionPath: null,
});
class ISession {
}
exports.ISession = ISession;
exports.GOAL_DURATION_DEFAULT = 30 * 60 * 1000; // 30 mins.
exports.GOAL_MAX_DURATION = 24 * 60 * 60 * 1000; // 24 hours.
exports.GOAL_REPEATS_DEFAULT = [true, true, true, true, true, true, true];
exports.buildGoal = (props = {}) => Object.assign({
    duration: exports.GOAL_DURATION_DEFAULT,
    type: 1 /* AT_LEAST */,
    repeats: exports.GOAL_REPEATS_DEFAULT,
}, props);



/** WEBPACK FOOTER **
 ** ./src/models.ts
 **/